<template>
    <v-row dense>
        <v-col cols="12" md="12">
            <v-card variant="outlined">
                <v-card-title>
                    <span class="font-weight-bold text-subtitle-2">
                        {{ t('penalty_no_show_conditions') }}
                    </span>
                </v-card-title>
                <v-card-text>
                    <v-row dense>
                        <v-col cols="12">
                            <div class="d-inline-flex flex-wrap align-center">
                                <span class="me-2">
                                    {{ t('penalty_no_show_description') }}
                                </span>
                                <NumberInputWithButtons
                                    v-model="noShowPenaltyCondition.price"
                                    :label="
                                        noShowPenaltyCondition.unitOfMeasurement === 'PERCENT'
                                            ? t('percent')
                                            : t('amount')
                                    "
                                    :width="180"
                                    class="me-2"
                                    :buttons="[
                                        {
                                            icon: 'mdi-percent',
                                            active: noShowPenaltyCondition.unitOfMeasurement === 'PERCENT',
                                            onClick: () => (noShowPenaltyCondition.unitOfMeasurement = 'PERCENT'),
                                        },
                                        {
                                            icon: 'mdi-cash',
                                            active: noShowPenaltyCondition.unitOfMeasurement === 'FIXED_VALUE',
                                            onClick: () => (noShowPenaltyCondition.unitOfMeasurement = 'FIXED_VALUE'),
                                        },
                                    ]"
                                    :append-text="
                                        noShowPenaltyCondition.unitOfMeasurement === 'FIXED_VALUE' ? currencyCode : null
                                    "
                                />
                                <template v-if="noShowPenaltyCondition.unitOfMeasurement === 'PERCENT'">
                                    <v-select
                                        v-model="noShowPenaltyCondition.priceType"
                                        hide-details
                                        :label="t('penalty_cancel_description.from_the')"
                                        :items="conditionPriceTypeItems"
                                    />
                                </template>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>
<script setup lang="ts">
    const {t} = useI18n()

    const noShowPenaltyCondition = defineModel()

    const props = defineProps<{
        currencyCode: string
        conditionPriceTypeItems: any[]
    }>()
</script>
